import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2.5 2 4 2 2-1 2-1",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M2 21h20", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 8v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 8v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17 8v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 4h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 4h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17 4h.01", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Cake";
const Cake = memo(themed(Icon));
export {
  Cake
};
//# sourceMappingURL=cake.js.map
